import React, { PureComponent } from 'react';

interface IProps {
  className?: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  title?: string;
}

export const contents = `
  <circle cx="12" cy="12" r="10" />
  <line x1="12" y1="6.063" x2="4" y2="6.063" />
  <line x1="7.439" y1="9.063" x2="2.439" y2="9.063" />
  <line x1="21.016" y1="8.063" x2="15.016" y2="8.063" />
  <path d="M21.887,13.5H18.719a3.427,3.427,0,0,1-2.443-.912,3.856,3.856,0,0,0-2.662-.895,3.857,3.857,0,0,0-2.663.895,3.426,3.426,0,0,1-2.442.912H5.551" />
  <path d="M20.985,16.393H18.558a3.427,3.427,0,0,0-2.443.912,3.856,3.856,0,0,1-2.662.895,3.857,3.857,0,0,1-2.663-.895,3.426,3.426,0,0,0-2.442-.912H7.672" />
  `;

export const defaultProps = {
  color: 'currentColor',
  size: 24,
  strokeWidth: 2,
  title: 'divider',
};

class IconPlanet extends PureComponent<IProps> {
  render() {
    const { color, size, title, strokeWidth, ...otherProps } = {
      ...defaultProps,
      ...this.props,
    };
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={0}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        {...otherProps}
      >
        <title>{title}</title>
        <g dangerouslySetInnerHTML={{ __html: contents }} />
      </svg>
    );
  }
}

export default IconPlanet;
